import type { FC } from "react";
import { Button, Container, Title } from "../../../shared/ui";
import { getRouteBlogs } from "../../../shared/constants/routes";
import { useMediaQuery } from "../../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../shared/constants/media";
import { useGetPostsQuery } from "../../../entities/Blog/api/blogApi";
import { BlogCard } from "../../../entities/Blog";

import styles from "./NewsAboutUs.module.scss";

export const NewsAboutUs: FC = () => {
    const matches = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.md));

    const newsToTake = matches ? 2 : 4;

    const { data: news, isLoading } = useGetPostsQuery({ take: newsToTake });

    return news?.length && !isLoading ? (
        <Container marginSize="standard" className={styles.container}>
            <Title className={styles.title} level={3}>
                Новости о&nbsp;нас
            </Title>
            <div className={styles.news}>{news?.map((item) => <BlogCard key={item.id} {...item} />)}</div>
            <Button as="link" to={getRouteBlogs()} className={styles.button}>
                Больше материалов
            </Button>
        </Container>
    ) : null;
};

export default NewsAboutUs;
